import React, { Component } from "react";
import { observer, inject } from "mobx-react";
import PropTypes from "prop-types";
import {
  GridContainer,
  GridRow,
  GridColumn,
  Loader,
  Input,
  Button,
  Toastr,
} from "arv-reactcomponents";
import { queryParamsToObject } from "../../utils";
import ProductCarousel from "../../component/ProductCarousel";
import { NO_RESULTS } from "npmlinks-constants";
import Analytics from "../../analytics";
import Event from "../../analytics/eventFactory";

const NORESULTS_CAROUSEL_SIZE = {
  XS: 2,
  SM: 2,
  MD: 2,
  LG: 2,
};
@inject("NoResultsStore", "CommonStore")
@observer
class NoResults extends Component {
  constructor() {
    super();
    this.state = {
      query: "",
    };
    this.init = this.init.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.updateQuery = this.updateQuery.bind(this);
  }
  componentDidMount() {
    this.init();
  }
  get queryInUrl() {
    return queryParamsToObject(this.props.location.search).q;
  }
  init() {
    const { isBrandPage, brandDetails } = this.props.CommonStore;
    Analytics.trackEvent({
      action: Event.action.ZERO_RESULTS,
      category: Event.category.SEARCH,
      label: `search=${this.queryInUrl}`,
      interaction: true,
    });
    if (!isBrandPage) {
      this.props.NoResultsStore.getGeneralNoResults();
    } else {
      const { id: brandId, legalBrandNames } = brandDetails;
      this.props.NoResultsStore.getBrandNoResults({ brandId, legalBrandNames });
    }
  }
  updateQuery(event) {
    this.setState({ query: event.target.value });
  }
  handleSubmit(event) {
    event.preventDefault();
    const { query } = this.state;
    if (!query) {
      Toastr.showToastr({
        className: "nwc-toastr-list-danger nw-toastr",
        message: NO_RESULTS.toastrMessage,
        timeout: 3000,
      });
    } else {
      this.props.history.replace(`/search?q=${query}`);
    }
  }
  render() {
    const { query } = this.state;
    const { loading, newArrivalData, onSaleData } = this.props.NoResultsStore;
    return (
      <GridContainer className="nw-noresults-container">
        <GridRow className="nw-noresults-inputrow">
          <GridColumn>
            <h3 className="nw-noresults-reultstitle">
              {NO_RESULTS.searchTitle} {this.queryInUrl}
            </h3>
            <form
              className="nw-noresults-form"
              onSubmit={this.handleSubmit}
              autoComplete="off"
            >
              <Input
                type="text"
                value={query}
                onChange={this.updateQuery}
                className="nw-noresults-input"
                placeholder={NO_RESULTS.searchPlaceholder}
              />
              <Button
                className="nw-noresults-applybutton"
                onClick={this.handleSubmit}
              >
                <i className="icomoon-search3" />
              </Button>
            </form>
          </GridColumn>
        </GridRow>
        <GridRow className="nw-noresults-productsrow">
          {(loading || newArrivalData.length > 0) && (
            <GridColumn className="nwc-grid-col-sm-6 nw-noresults-productscolumn">
              {loading && <Loader />}
              {!loading && (
                <ProductCarousel.component
                  size={NORESULTS_CAROUSEL_SIZE}
                  title={NO_RESULTS.productCarouselTitle1}
                  list={newArrivalData}
                  viewAllLink={
                    newArrivalData.length >= NO_RESULTS.MIN_SIZE &&
                    NO_RESULTS.newArrivals
                  }
                  origin={NO_RESULTS.productCarouselTitle1}
                />
              )}
            </GridColumn>
          )}
          {(loading || onSaleData.length > 0) && (
            <GridColumn className="nwc-grid-col-sm-6 nw-noresults-productscolumn">
              {loading && <Loader />}
              {!loading && (
                <ProductCarousel.component
                  size={NORESULTS_CAROUSEL_SIZE}
                  title={NO_RESULTS.productCarouselTitle2}
                  list={onSaleData}
                  viewAllLink={
                    onSaleData.length >= NO_RESULTS.MIN_SIZE &&
                    NO_RESULTS.onSale
                  }
                  origin={NO_RESULTS.productCarouselTitle2}
                />
              )}
            </GridColumn>
          )}
        </GridRow>
      </GridContainer>
    );
  }
}

NoResults.wrappedComponent.propTypes = {
  NoResultsStore: PropTypes.shape({
    getBrandNoResults: PropTypes.func.isRequired,
    getGeneralNoResults: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired,
    newArrivalData: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    onSaleData: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  }).isRequired,
  CommonStore: PropTypes.shape({
    isBrandPage: PropTypes.bool.isRequired,
    brandDetails: PropTypes.shape({}).isRequired,
  }).isRequired,
  location: PropTypes.shape({
    search: PropTypes.string.isRequired,
  }).isRequired,
  history: PropTypes.shape({
    replace: PropTypes.func.isRequired,
  }).isRequired,
};
const getFinalComponent = component =>
  inject("NoResultsStore", "CommonStore")(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: NoResults.wrappedComponent,
  component: NoResults,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/pages/NoResults/index.js